import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
const API_URL = environment.apiUrl + 'team-members';
@Injectable({
    providedIn: 'root'
})
export class TeamMembersService {
    authtoken: string;
    private httpOptions;
    constructor(private http: HttpClient, private token: TokenStorageService) {
        this.authtoken = this.token.getToken();
        this.httpOptions = {
            headers: new HttpHeaders()
                .set("Content-Type", "application/json")
                .set('Authorization', `Bearer ${this.authtoken}`)
        };
    }
    getTeamMembersList(query): Observable<any> {
        return this.http.get(API_URL + query);
    }
    getTeamMembersListWithoutAuth(query): Observable<any> {
        return this.http.get(API_URL + '/v1' + query);
    }
    getTeamMembersDetails(id): Observable<any> {
        return this.http.get(API_URL + '/' + id);
    }
    getTeamMembersDetailsWithoutAuth(id): Observable<any> {
        return this.http.get(API_URL + '/v1/' + id);
    }
    updateTeamMembers(id, data): Observable<any> {
        return this.http.put(API_URL + '/' + id, data);
    }
    addTeamMembers(productdata): Observable<any> {
        return this.http.post(API_URL, productdata);
    }
}